import React, { useState, useCallback, memo } from 'react';
import TooltipPortal from './tooltip/TooltipPortal';

export const BetaBadge = ({
    label = 'Beta',
    tooltip = 'This feature is in beta. Expect possible issues or changes.',
    className = '',
}) => {
    const [isHovering, setIsHovering] = useState(false);

    const handleMouseEnter = useCallback(() => setIsHovering(true), []);
    const handleMouseLeave = useCallback(() => setIsHovering(false), []);

    return (
        <TooltipPortal tooltip={tooltip} show={isHovering}>
            <span
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                className={className}
                style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '11px',
                    fontWeight: 700,
                    padding: '4px 8px',
                    borderRadius: '8px',
                    letterSpacing: '0.02em',
                    lineHeight: 1,
                    textTransform: 'uppercase',
                    background: 'var(--color-gray-light)',
                    color: 'var(--color-gray-dark)',
                    border: '1px solid var(--color-border-gray)',
                    cursor: 'default',
                    userSelect: 'none',
                }}
            >
                {label}
            </span>
        </TooltipPortal>
    );
};

export default memo(BetaBadge);
